import React from 'react';
import { Form, Input, Row, Col, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

const ConfigureDeviceModal = (props) => {
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const { t } = useTranslation();

  const onFinish = (values) => {
    console.log('Received values:', values);
    props.action(values);
    props.close();
  };

  return (
    <Modal
      title={t("DevicePage.configureDevice")}
      open={props.visible}
      onOk={() => form.submit()}
      okText={t("Send")}
      onCancel={props.close}
    >
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={props.selectedDevice}
        layout="vertical"
      >
        <p>{t("DevicePage.table.id")}: <span style={{fontWeight:'bold'}}>{props.selectedDevice ? props.selectedDevice.Id : ''}</span></p>
        <p>{t("DevicePage.deviceModal.lastModified")}: <span style={{fontWeight:'bold'}}>{props.selectedDevice ? props.selectedDevice["LAST DATA"] : ''}</span></p>
        
        <Row gutter={16}>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.macAddress")}
              name="MAC"
              rules={[{ required: true, message: t("DevicePage.deviceModal.macAddressRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24} lg={12}>
            <Form.Item
              label={t("DevicePage.deviceModal.name")}
              name="NAME"
              rules={[{ required: true, message: t("DevicePage.deviceModal.nameRequired") }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label={t("DevicePage.deviceModal.configuration")}
              name="CONFIGURATION"
              rules={[{ required: true, message: t("DevicePage.deviceModal.configurationRequired") }]}
            >
              <TextArea />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ConfigureDeviceModal;
